enum TableColumnSize {
    EQUAL = 'equal',
    WIDE_FIRST_COLUMN = 'wide_first_column',
}

export default TableColumnSize;
